jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });

});

/* rit-westwing-search-2026-10-06 */
(function () {
  'use strict';

  var canvasSelector = '#nt_search_canvas';
  var cache = new Map();

  function text(value) {
    return String(value || '').trim();
  }

  function create(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function highlightedLabel(label, query) {
    var fragment = document.createDocumentFragment();
    var source = text(label);
    var lower = source.toLowerCase();
    var needle = text(query).toLowerCase();
    var index = needle ? lower.indexOf(needle) : -1;

    if (index < 0) {
      fragment.appendChild(document.createTextNode(source));
      return fragment;
    }

    fragment.appendChild(document.createTextNode(source.slice(0, index)));
    var match = create('span', 'rit-search-match');
    match.textContent = source.slice(index, index + needle.length);
    fragment.appendChild(match);
    fragment.appendChild(document.createTextNode(source.slice(index + needle.length)));
    return fragment;
  }

  function resultUrl(item, fallbackQuery) {
    return item && item.url ? item.url : '/search?q=' + encodeURIComponent(fallbackQuery);
  }

  function renderLinks(container, items, query, property) {
    container.replaceChildren();
    items.slice(0, 5).forEach(function (item) {
      var label = text(item[property]);
      if (!label) return;
      var link = create('a');
      link.href = resultUrl(item, label);
      link.appendChild(highlightedLabel(label, query));
      container.appendChild(link);
    });
  }

  function resizedImage(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', '360');
      return parsed.href;
    } catch (error) {
      return url;
    }
  }

  function renderProducts(container, products) {
    container.replaceChildren();
    products.slice(0, 6).forEach(function (product) {
      var image = product.image || (product.featured_image && product.featured_image.url);
      if (!image || !product.url) return;

      var link = create('a', 'rit-search-product-card');
      link.href = product.url;
      link.setAttribute('aria-label', text(product.title));

      var img = create('img');
      img.src = resizedImage(image);
      img.alt = text((product.featured_image && product.featured_image.alt) || product.title);
      img.loading = 'lazy';
      img.decoding = 'async';

      var title = create('span');
      title.textContent = text(product.title);
      link.appendChild(img);
      link.appendChild(title);
      container.appendChild(link);
    });
  }

  function normalizeQueries(queries, query) {
    var seen = new Set();
    var output = [];
    [{ text: query, url: '/search?q=' + encodeURIComponent(query) }].concat(queries || []).forEach(function (item) {
      var label = text(item.text);
      var key = label.toLowerCase();
      if (!label || seen.has(key)) return;
      seen.add(key);
      output.push(item);
    });
    return output;
  }

  function setup(canvas) {
    var shell = canvas.querySelector('[data-rit-search-shell]');
    var input = canvas.querySelector('[data-rit-search-input]');
    if (!shell || !input || input.dataset.ritSearchBound === 'true') return;

    var form = canvas.querySelector('[data-rit-search-form]');
    var intro = canvas.querySelector('[data-rit-search-intro]');
    var empty = canvas.querySelector('[data-rit-search-empty]');
    var results = canvas.querySelector('[data-rit-search-results]');
    var suggestions = canvas.querySelector('[data-rit-search-suggestions]');
    var collections = canvas.querySelector('[data-rit-search-collections]');
    var products = canvas.querySelector('[data-rit-search-products]');
    var showMore = canvas.querySelector('[data-rit-search-show-more]');
    var progress = canvas.querySelector('[data-rit-search-progress]');
    var timer = 0;
    var controller = null;

    input.dataset.ritSearchBound = 'true';
    canvas.dataset.ritSearchEnhanced = 'true';

    function setLoading(loading) {
      progress.hidden = !loading;
      input.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    function reset() {
      if (controller) controller.abort();
      setLoading(false);
      intro.hidden = false;
      empty.hidden = true;
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function render(payload, query) {
      var resourceResults = payload && payload.resources && payload.resources.results ? payload.resources.results : {};
      var queryItems = normalizeQueries(resourceResults.queries, query);
      var collectionItems = resourceResults.collections || [];
      var productItems = resourceResults.products || [];
      var hasResults = queryItems.length || collectionItems.length || productItems.length;

      intro.hidden = true;
      empty.hidden = Boolean(hasResults);
      results.hidden = !hasResults;
      input.setAttribute('aria-expanded', hasResults ? 'true' : 'false');

      renderLinks(suggestions, queryItems, query, 'text');
      renderLinks(collections, collectionItems, query, 'title');
      renderProducts(products, productItems);
      canvas.querySelector('.rit-search-products').hidden = productItems.length === 0;
      showMore.href = form.action + '?type=product&q=' + encodeURIComponent(query);
    }

    function search(query) {
      if (cache.has(query)) {
        render(cache.get(query), query);
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();
      setLoading(true);

      var url = new URL('/search/suggest.json', window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product,collection,query');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');

      fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        signal: controller.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.json();
        })
        .then(function (payload) {
          cache.set(query, payload);
          if (cache.size > 20) cache.delete(cache.keys().next().value);
          if (text(input.value).toLowerCase() === query) render(payload, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          intro.hidden = true;
          results.hidden = true;
          empty.hidden = false;
        })
        .finally(function () {
          if (text(input.value).toLowerCase() === query) setLoading(false);
        });
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var query = text(input.value).toLowerCase();
      if (query.length < 2) {
        reset();
        return;
      }
      timer = window.setTimeout(function () { search(query); }, 220);
    });

    form.addEventListener('submit', function (event) {
      var query = text(input.value);
      if (!query) {
        event.preventDefault();
        input.focus();
      }
    });

    reset();
  }

  function setupAll() {
    document.querySelectorAll(canvasSelector).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  if ('MutationObserver' in window) {
    new MutationObserver(setupAll).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
/* /rit-westwing-search-2026-10-06 */

/* rit-localized-dimension-image-fallback-2026-10-08 */
(function () {
  'use strict';

  var selector = '.custom-product-section .image-card img';
  var canonicalImageRequests = new Map();

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function canonicalImage(handle) {
    if (canonicalImageRequests.has(handle)) return canonicalImageRequests.get(handle);

    var request = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Canonical product request failed');
        return response.json();
      })
      .then(function (product) {
        var documentCopy = new DOMParser().parseFromString(product.description || '', 'text/html');
        var image = documentCopy.querySelector(selector);
        return image ? image.getAttribute('src') || '' : '';
      })
      .catch(function () { return ''; });

    canonicalImageRequests.set(handle, request);
    return request;
  }

  function repair(image) {
    if (image.dataset.ritDimensionFallbackAttempted === 'true') return;
    image.dataset.ritDimensionFallbackAttempted = 'true';

    var handle = productHandle();
    if (!handle) return;

    canonicalImage(handle).then(function (source) {
      if (!source) return;

      var current = image.getAttribute('src') || '';
      if (source !== current) {
        image.src = source;
        return;
      }

      try {
        var retryUrl = new URL(source, window.location.origin);
        retryUrl.searchParams.set('_rit_retry', Date.now().toString());
        image.src = retryUrl.href;
      } catch (error) {
        image.src = source;
      }
    });
  }

  function bind(image) {
    if (image.dataset.ritDimensionFallbackBound === 'true') return;
    image.dataset.ritDimensionFallbackBound = 'true';
    image.addEventListener('error', function () { repair(image); });
    if (image.complete && image.naturalWidth === 0) repair(image);
  }

  function setup() {
    document.querySelectorAll(selector).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  if ('MutationObserver' in window) {
    new MutationObserver(setup).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
/* /rit-localized-dimension-image-fallback-2026-10-08 */
